const ValuationTypeEnum = Object.freeze({
    GROWTHINVEST: 'GROWTHINVEST',
    FUND: 'FUND',
    STOCK_EXCHANGE: 'STOCK_EXCHANGE',
    INSOLVENT: 'INSOLVENT'
});

export default ValuationTypeEnum;
